const SearchJobs = {
    JOB_DETAIL: 'JOB_DETAIL',
    GET_OVERVIEW: 'GET_OVERVIEW',
    SET_ORDERING: 'SET_ORDERING',
    TOGGLE_JOBSEARCH_FORM: 'TOGGLE_JOBSEARCH_FORM',
    SET_BASE_URL: 'SET_BASE_URL'
};

export default SearchJobs;